var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_message",
    "data-name": "vuesax/bulk/message",
    transform: "translate(-684 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,10.97V4.99A4.993,4.993,0,0,1,5,0H15a4.993,4.993,0,0,1,5,4.99v6.98a4.991,4.991,0,0,1-5,4.98H13.5a1.014,1.014,0,0,0-.8.4l-1.5,1.99a1.421,1.421,0,0,1-2.4,0L7.3,17.35a1.112,1.112,0,0,0-.8-.4H5a4.991,4.991,0,0,1-5-4.98Z",
    transform: "translate(686 190)",
    fill: "#9997a8",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(695 198)",
    fill: "#9997a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(699 198)",
    fill: "#9997a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M1,2A1,1,0,1,1,2,1,1,1,0,0,1,1,2Z",
    transform: "translate(691 198)",
    fill: "#9997a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(684 188)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.6cf7714f96f2ac4ea417129b9ea12711.svg";
export { ForwardRef as ReactComponent };